import { render, staticRenderFns } from "./inpBox.vue?vue&type=template&id=00a1916b&scoped=true"
import script from "./inpBox.vue?vue&type=script&lang=js"
export * from "./inpBox.vue?vue&type=script&lang=js"
import style0 from "./inpBox.vue?vue&type=style&index=0&id=00a1916b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a1916b",
  null
  
)

export default component.exports